import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import flow from "lodash/fp/flow";
import constants from "../../core/constants";
import moment from "moment";
class PrivateBusRequestsPageTransform {
  constructor() {
    "ngInject";
    this.item = {
      title: "Private Bus Request",
      state: "privatebusrequest",
      name: "privatebusrequest",
    };
    this.filters = [
      {
        name: "outbound_trip_date",
        title: "Travel Date",
        hasRange: false,
        icon: "date_range",
        isDate: true,
      },
      {
        name: "status",
        title: "status",
        icon: "check_circle_outline",
        list: "privateBusStatus",
      },
      { name: "from_city", title: "From", icon: "", resource: "City" },
      { name: "to_city", title: "To", icon: "", resource: "City" },
      { name: "is_round_trip", title: "is Round Trip", list: "isRoundTrip" },
    ];
    this.fields = [
      { title: "Travel Date", name: "outbound_trip_date" },
      { title: "From", name: "from_city" },
      { title: "To", name: "to_city" },
      { title: "Status", name: "status" },
      { title: "Round Trip", name: "is_round_trip" },
    ];
  }

  justify(data) {
    const getSource = (item) => assign({ _id: item._id }, item._source);
    const formatDateandStatus = (item) => {
      item.outbound_trip_date = moment(item.outbound_trip_date).format(
        constants.dateTimeFormat
      );
      if (item.status === "pending_operations") {
        item.status = "Pending Operations";
      }
      if (item.status === "pending_payment") {
        item.status = "Pending Payment";
      }
      if (item.status === "unsatisfiable") {
        item.status = "Rejected";
      }
      return item;
    };

    return map(flow([getSource, formatDateandStatus]))(data);
  }
}

export default PrivateBusRequestsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/privateBusRequests/privateBusRequests.transforms.js